
































































































import {
  Vue,
  Component,
  Watch,
} from "@/shared/vuepack";
import {
  FetchState,
} from "@/shared/types";
import Input from "@/shared/components/ui/Input.vue";
import Button from "@/shared/components/ui/Button.vue";
import RadioButton from "@/shared/components/ui/RadioButton.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useUserStore } from "@/shared/store/user";
import { useWizardStore } from "@/employee/store/wizard";
import { useIdentityChallengeStore } from "@/employee/store/identityChallenge";

@Component({
  components: {
    Input,
    Button,
    RadioButton,
    GenericLoadingSpinner
  }
})
export default class IdentityChallenge extends Vue {
  identityStore = useIdentityChallengeStore();
  custodianSettingsStore = useCustodianSettingsStore();
  userStore = useUserStore();
  wizardStore = useWizardStore();
  portalCustomizationStore = usePortalCustomizationStore();

  pollingMethod?: any = null;

  get isLoading () {
    return this.identityStore.fetchState === FetchState.Loading ||
        (this.didFailChallenge && !this.portalCustomizationStore.isSupportInfoLoaded) ||
        this.interpretStatus === "pass";
  }

  get hasQuestions () {
    return this.identityStore.questions.length > 0;
  }

  get hasAllAnswers () {
    return this.identityStore.answers.length > 0 && this.identityStore.answers.every(a => !!a);
  }

  get interpretStatus () {
    switch (this.identityStore.verifyIdentityStatus) {
      case "NeedInfo":
        return "answer";

      case "DocumentsRequested":
        return "documentsRequested";

      case "Pass":
        return "pass"; // this whole control should not show anymore!

      case "Fail":
      case "RetryLimitReached":
        return "fail";

      case "TimedOut":
        return "retry";

      case "PromptDob":
      case "PromptSsn":
      case "PromptDobAndSsn":
        return "reenter";

      case "Error":
        return "error";

      default:
        return "none";
    }
  }

  get didFailChallenge () {
    return this.interpretStatus === "fail";
  }

  get shouldShowInstructions () {
    return this.interpretStatus === "answer";
  }

  get shouldShowQuestions () {
    return !this.isLoading &&
        (this.interpretStatus === "answer" || this.interpretStatus === "none");
  }

  get didEnterBadInfo () {
    return this.interpretStatus === "reenter";
  }

  get errorOccured () {
    return this.interpretStatus === "error";
  }

  get shouldRestart () {
    return this.interpretStatus === "retry";
  }

  get showGetQuestionsButton () {
    return !this.hasQuestions && !this.isLoading &&
        (this.interpretStatus === "answer" || this.interpretStatus === "none" || this.interpretStatus === "retry");
  }

  get showDocumentsRequested () {
    return this.interpretStatus === "documentsRequested";
  }

  created () {
    this.custodianSettingsStore.getCustodianSettings();
  }

  mounted () {
    this.getChallengeQuestionsWithRetry();
    if (this.showDocumentsRequested) {
      this.startWizardPolling();
    }
  }

  beforeDestroy () {
    this.stopWizardPolling();
  }

  pollWizardState () {
    return this.wizardStore.getWizardState({ force: true })
        .then(_ => {
          if (this.wizardStore.isComplete) {
            this.$emit("complete");
          }
        });
  }

  startWizardPolling () {
    this.pollingMethod = setInterval(this.pollWizardState, 15 * 1000);
  }

  stopWizardPolling () {
    if (this.pollingMethod) {
      clearInterval(this.pollingMethod);
      this.pollingMethod = null;
    }
  }

  @Watch("showDocumentsRequested")
  onShowDocumentsRequestedChanged () {
    if (this.showDocumentsRequested) {
      this.startWizardPolling();
    } else {
      this.stopWizardPolling();
    }
  }

  @Watch("identityStore.verifyIdentityStatus")
  onSucceeded () {
    if (this.interpretStatus === "pass") {
      this.$emit("complete");
    }
  }

  getChallengeQuestionsWithRetry () {
    this.identityStore.getChallengeQuestions({
      userCustodian: this.custodianSettingsStore.userCustodian,
      isDirectSignup: this.userStore.isIndividualAccountType
    });
  }

  selectAnswerForIndex (index: number, answer: string) {
    this.identityStore.setAnswerForQuestion({ index, answer });
  }

  submitIdentityChallengeAnswers () {
    if (this.identityStore.hasAnsweredWave1) {
      this.identityStore.submitWave2Answers();
    } else {
      this.identityStore.submitWave1Answers();
    }
  }


}
